/** Shared styling + helpers for the /environmental area (always light, independent of the site theme). */

export const ui = {
  card:      'bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-3xl shadow-sm',
  input:     'w-full h-11 rounded-xl border-2 border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-900 px-3 text-[15px] text-slate-900 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-500 outline-none focus:border-yellow-500',
  label:     'block text-sm font-semibold text-slate-600 dark:text-slate-300 mb-1',
  btn:       'inline-flex items-center justify-center rounded-xl bg-yellow-400 px-5 py-2.5 font-bold text-black transition-colors hover:bg-yellow-500 disabled:cursor-not-allowed disabled:opacity-50',
  btnGhost:  'inline-flex items-center justify-center rounded-xl border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-900 px-3 py-1.5 text-sm font-semibold text-slate-700 dark:text-slate-200 transition-colors hover:bg-slate-50 dark:hover:bg-slate-800 disabled:cursor-not-allowed disabled:opacity-40',
  btnDanger: 'inline-flex items-center justify-center rounded-xl border border-red-200 dark:border-red-900 bg-white dark:bg-slate-900 px-3 py-1.5 text-sm font-semibold text-red-600 dark:text-red-400 transition-colors hover:bg-red-50 dark:hover:bg-red-950 disabled:opacity-40',
  muted:     'text-sm text-slate-500 dark:text-slate-400',
} as const;

export type QType  = 'agreedisagree' | 'yesno' | 'yesyes';
export type Choice = 'agree' | 'disagree';
export interface Answer { type: QType; en: string; ar: string; answer: Choice }

export const QTYPE_LABEL: Record<QType, string> = {
  agreedisagree: 'Agree / Disagree',
  yesno:         'Yes / No',
  yesyes:        'Yes / Yes (one green, one red)',
};

/** Human label for a stored answer, e.g. "Yes", "Disagree". */
export function answerLabel(type: QType, answer: Choice): string {
  if (type === 'agreedisagree') return answer === 'agree' ? 'Agree' : 'Disagree';
  return answer === 'agree' ? 'Yes' : 'No';
}

/** Readable message from a tRPC error (validation errors arrive as a JSON list). */
export function errText(e: unknown): string {
  const msg = (e as { message?: string } | null)?.message ?? 'Something went wrong';
  try {
    const issues = JSON.parse(msg);
    if (Array.isArray(issues) && issues[0]?.message) return String(issues[0].message);
  } catch { /* plain message */ }
  return msg;
}
